import { Unionize } from "fond/types";

export const AutoDesignConfirmModalType = ["replaceDesign", "replaceLayer", "unsavedEdits"] as const;
export type AutoDesignConfirmModalType = Unionize<typeof AutoDesignConfirmModalType>;
